module.exports = __webpack_public_path__ + "static/media/icn_user.fbc32bea.png";